
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":".033","width":"14","height":"9","fill":"#000"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 .033h14v9H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.194 4.033l-3.889-3-.61.792 2.727 2.104H1v1h9.422L7.695 7.033l.61.791 3.89-3 .512-.395-.513-.396z"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.194 4.033l-3.889-3-.61.792 2.727 2.104H1v1h9.422L7.695 7.033l.61.791 3.89-3 .512-.395-.513-.396z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.305 1.033l.123-.159-.159-.122-.122.159.158.122zm3.89 3l-.123.158.122-.158zm-4.5-2.209l-.159-.122-.122.159.158.122.123-.159zm2.727 2.105v.2h.587l-.465-.359-.122.159zM1 3.929v-.2H.8v.2H1zm0 1H.8v.2H1v-.2zm9.422 0l.122.158.465-.358h-.587v.2zM7.695 7.033l-.123-.159-.158.123.122.158.159-.122zm.61.791l-.158.123.122.158.159-.122-.123-.159zm3.89-3l-.123-.158.122.158zm.512-.395l.123.158.205-.158-.205-.159-.123.159zM8.183 1.19l3.89 3 .243-.317-3.888-3-.245.317zm-.33.756l.61-.792L8.148.91l-.61.791.316.245zm2.691 1.823L7.817 1.666l-.245.317L10.3 4.087l.244-.317zM1 4.13h9.422v-.4H1v.4zm.2.8v-1H.8v1h.4zm9.222-.2H1v.4h9.422v-.4zM7.817 7.19l2.727-2.104-.244-.317-2.728 2.104.245.317zm.647.511l-.611-.791-.317.244.611.792.317-.245zm3.608-3.036l-3.889 3 .245.317 3.888-3-.244-.317zm.513-.396l-.513.396.245.317.513-.396-.245-.317zm-.513-.079l.513.396.245-.317-.514-.396-.244.317z","fill":"#fff","mask":"url(#a)"}})])
          )
        }
      }
    